export function DarkBackground(aBackgroundColor) 
{
    return false
    try
    {
        const colorString = aBackgroundColor.replace("#","")
        const red = parseInt(colorString.substring(0,2), 16)
        const green = parseInt(colorString.substring(2,4), 16)
        const blue = parseInt(colorString.substring(4,6), 16)
        const luma = 0.2126 * red + 0.7152 * green + 0.0722 * blue; // per ITU-R BT.709
        return (luma < 100) 
    }
    catch
    {
        return false
    }
}

export function IsBetaSite() {
    return window.location.href.includes("beta")
}

export function UrlBase64ToUint8Array(base64String) {
    const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding)
        .replace(/\-/g, "+")
        .replace(/_/g, "/");

    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);

    for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
};

export function MakeOsLocaleInfoShortDate(aDateTime) 
{
    try 
    {
        const NowDate = new Date()
        const ThenDate = new Date(aDateTime + " UTC")
        if ((NowDate.getFullYear() === ThenDate.getFullYear())
            && (NowDate.getMonth() === ThenDate.getMonth())
            && (NowDate.getDate() === ThenDate.getDate()))
        {
            return ThenDate.toLocaleTimeString()
        }
        else
        {
            return ThenDate.toLocaleDateString()
        }
    } 
    catch
    {
        return ""
    }
} 

export function NowInDateTimeFormat() 
{
    const NowDate = new Date()
    const Year = NowDate.getUTCFullYear()
    const Month = NowDate.getUTCMonth() + 1 //for whatever stupid reason, month is zero-based
    const Day = NowDate.getUTCDate()
    const Hours = NowDate.getUTCHours()
    const Minutes = NowDate.getUTCMinutes()
    const Seconds = NowDate.getUTCSeconds()
    
    return Year + "-" + 
        (Month < 10 ? "0" : "") + Month + "-" +
        (Day < 10 ? "0" : "") + Day + " " +
        (Hours < 10 ? "0" : "") + Hours + ":" +
        (Minutes < 10 ? "0" : "") + Minutes + ":" +
        (Seconds < 10 ? "0" : "") + Seconds
} 

export function NowInDateTimeFormatISO8601() 
{
    const NowDate = new Date()
    const Year = NowDate.getUTCFullYear()
    const Month = NowDate.getUTCMonth() + 1 //for whatever stupid reason, month is zero-based
    const Day = NowDate.getUTCDate()
    const Hours = NowDate.getUTCHours()
    const Minutes = NowDate.getUTCMinutes()
    const Seconds = NowDate.getUTCSeconds()
    
    return Year + "-" + 
        (Month < 10 ? "0" : "") + Month + "-" +
        (Day < 10 ? "0" : "") + Day + "T" +
        (Hours < 10 ? "0" : "") + Hours + ":" +
        (Minutes < 10 ? "0" : "") + Minutes + ":" +
        (Seconds < 10 ? "0" : "") + Seconds +
        "Z"
}

export function TimeDifferenceInMinutesAndSeconds(start, end) 
{
    if (start == null || end == null) return '-';

    const diffInSeconds = Math.max(0, Math.floor((end - start) / 1000));
    const minutes = String(Math.floor(diffInSeconds / 60)).padStart(2, '0');
    const seconds = String(diffInSeconds % 60).padStart(2, '0');

    return `${minutes}:${seconds}`;
}

export function  MakeOsLocaleInfoLongDateTime(aDateTime) 
{
    return aDateTime.toLocaleDateString() + " " + aDateTime.toLocaleTimeString()
} 

export function OpenPopup(aUrl)  
{
    window.open(aUrl, "_blank")
}

export function GetBrandButtonClass(aBrand)
{
  return aBrand === "enreach" || aBrand === "summa" ? "brandbutton" : "brandbuttonkeeporiginalstyle" 
}

export function IsEmptyString(aString)  
{
    return aString === undefined
        || aString === null
        || !aString
        || aString === '""'
}

export function GetCallHistory() 
{
    let CallHistory = GetCallHistoryFromLocalStorage()
    const HistoryCallRecognition = GetHistoryCallRecognition()

    try 
    {
        CallHistory = CallHistory.map(item => {
            const Match = HistoryCallRecognition[item.CallId]
            if (Match)
            {
                return { ...item, 
                    Application: Match.application || "", 
                    Name: Match.name || "",
                    Scripts: Match.scripts || "" }
            }
            else
            {
                return item
            }
        });
    } catch {}

    return CallHistory
}

export function GetCallHistoryFromLocalStorage() 
{
    const CallHistoryString = localStorage.getItem("callhistory")
    if (!IsEmptyString(CallHistoryString))
    {
        try { return JSON.parse(CallHistoryString) } catch {}
    }
    return []
}

export function GetHistoryCallRecognition() 
{
    const HistoryCallRecognition = localStorage.getItem("HistoryCallRecognition")
    if (!IsEmptyString(HistoryCallRecognition))
    {
        return JSON.parse(HistoryCallRecognition)
    }
    else
    {
        return {}
    }
}

export function SetCallHistoryFromLocalStorage(callHistoryJson) {
    if (callHistoryJson != undefined)
        localStorage.setItem("callhistory", JSON.stringify(callHistoryJson));
} 

export function IsPhoneNumber(value)
{
    const allowedCharacters = "0123456789+"
    const regex = new RegExp(`^[${allowedCharacters}]+$`)
    return regex.test(value);
}

export function GetPropertyByValue(obj, value) 
{
    return Object.keys(obj).find(key => obj[key] === value);
}

export async function AsyncWait(ms) 
{
    return new Promise(resolve => setTimeout(resolve, ms));
}

export function LocalizedDateTime(DateInteger) 
{
    const date = new Date(DateInteger)
    const systemLocale = navigator.language
    return new Intl.DateTimeFormat(systemLocale, {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
    }).format(date)
}

export function LocalStorageGetNumber(id)
{
    const stringValue = localStorage.getItem(id)
    return !IsEmptyString(stringValue) ? parseInt(stringValue,10) : null
}

export function LocalStorageSetNumber(id,value)
{
    if (value !== null)
    {
        localStorage.setItem(id,value.toString())
    }
    else
    {
        localStorage.removeItem(id)
    }
}

export function BroadcastBuffered(broadcaster, broadcastmessage, value, localstorage_valueidentifier, localstorage_timeoutidentifier, bufferLengthMs = 1000)
{
    // Clear the previous timeout
    // Clearing non-existant or expired id's does nothing
    var previousTimeoutId = localStorage.getItem(localstorage_timeoutidentifier);
    clearTimeout(previousTimeoutId ? parseInt(previousTimeoutId) : "");

    // Broadcast note update after bufferLengthMs
    const newTimeoutId = setTimeout(() => {
        // Check if other browser window has interrupted this window's notes update
        var timeoutId = localStorage.getItem(localstorage_timeoutidentifier);
        if (timeoutId != newTimeoutId) {
            console.log("Other browser window interrrupted this window's buffered update, aborting.");
            return;
        }

        localStorage.setItem(localstorage_timeoutidentifier, "");
        localStorage.setItem(localstorage_valueidentifier, value)
        broadcaster.postMessage(broadcastmessage);
    }, bufferLengthMs).toString();

    // Store the new timeout id
    localStorage.setItem(localstorage_timeoutidentifier, newTimeoutId);    
}

export async function RemoveServiceWorker()
{
    if ('serviceWorker' in navigator) 
    {
        const registrations = await navigator.serviceWorker.getRegistrations()
        await registrations.forEach(async (registration) => {
            await registration.unregister();
            console.info('Old service worker was removed.');
            localStorage.removeItem("ServiceWorkerVersion")
        });
    }
}

export function GetRecognitionFieldTypeValue(aFieldType,aRecognitionFieldTypes,aRecognitionFields)
{
    const NameIdentifier = GetPropertyByValue(aRecognitionFieldTypes, aFieldType)
    if (!IsEmptyString(NameIdentifier))
    {
        return aRecognitionFields[NameIdentifier]
    }
    
    return ""
}

export function ucfirst(string) 
{
    return !string ? "" : string.charAt(0).toUpperCase() + string.slice(1);
}

export function explode(input,separator,removedelimiter,adddelimiter) {
  if (typeof input !== 'string') return [];

  return input
    .split(separator)
    .map(item => item.trim())
    .map(item => item.trim(removedelimiter))
    .filter(item => item.length > 0)
    .map(item => adddelimiter + item + adddelimiter)
}